import type { UserRoleType } from "@/contexts/AuthContext";

/**
 * Where a signed-in user belongs when no explicit destination was requested.
 *
 * Nursery-level users — managers included — work from the Workspace, so the
 * dashboard is not their home (NAU-42). Everyone else, `UNKNOWN` included, goes
 * to the dashboard: a settled `UNKNOWN` means no platform role, no active
 * membership and no nursery access, and the authenticated layout turns that
 * into the /no-access screen. Holding those users back here would strand them.
 *
 * Callers must have a resolved session. `userRoleType` is derived from the same
 * object as `isAuthenticated`, so any authenticated user already has a settled
 * role — but a caller that has only just signed in does not, and should route
 * through the `_auth` layout rather than calling this with a stale value.
 */
export function resolveLandingRoute(userRoleType: UserRoleType): string {
  const isNurseryUser =
    userRoleType === "NURSERY_MANAGER" ||
    userRoleType === "NURSERY_DEPUTY_MANAGER" ||
    userRoleType === "NURSERY_LEADER" ||
    userRoleType === "NURSERY_PRACTITIONER";

  return isNurseryUser ? "/checklists" : "/dashboard";
}
